<div *ngFor="let role of list">
  <app-links-item *ngFor="let label of labels[role]; let i = index" [color]="colors[role][i]" [icon]="icons[role][i]" [label]="label">
    <div app-links-item-content-description>
      <div class="font-extra-small">{{ (label + '_ROLE/TEXT') | translate }}</div>
    </div>
    <div app-links-item-content-option>
      <app-links-item-option class="d-block mx-1" [symbol]="'check'" [selected]="roles.has(role)" (sendSelected)="receiveSelect($event, role)"></app-links-item-option>
    </div>
  </app-links-item>
</div>